import classNames from 'classnames';
import { Pencil, Trash2 } from 'lucide-react';
import React, { useEffect, useRef } from 'react';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import EmptyButton from 'ud-ui/components/empty-button';
import UDTippy from 'ud-ui/components/tippy';

interface IProps {
  id: number;
  name?: string;
  background?: 'dark' | 'light';
  isLoading?: boolean;
  /** Flash the row and scroll it into view — used right after a duplicate. */
  isHighlighted?: boolean;
  onClick: (id: number) => void;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

function MediaManagerTemplateListElement(props: IProps) {
  const { id, name, background, isHighlighted, onClick, onEdit, onDelete } = props;
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isHighlighted) return;
    rootRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [isHighlighted]);

  return (
    <div
      ref={rootRef}
      // The striped background is dropped while highlighted: two `bg-*` utilities
      // have equal specificity, so the winner would depend on stylesheet order.
      className={classNames('flex h-[60px] items-center justify-between border-l-4 p-2 transition-colors duration-500', {
        'border-transparent bg-white': !isHighlighted && background === 'light',
        'border-transparent bg-[#F7F7F7]': !isHighlighted && background === 'dark',
        'border-accentNaplesYellow bg-accentCornsilk': isHighlighted,
      })}
    >
      <EmptyButton
        centered={false}
        onClick={() => onClick(id)}
        icon={
          <UDText isNew type={'body-2'} color={'inherit'}>
            {name}
          </UDText>
        }
      />
      <div className={'flex'} style={{ gap: 24 }}>
        <UDTippy content={'Редактировать'} placement={'top'}>
          <EmptyButton icon={<Pencil size={20} />} onClick={() => onEdit(id)} />
        </UDTippy>
        <UDTippy content={'Удалить'} placement={'top'}>
          <EmptyButton color={theme.colors.CaseError} icon={<Trash2 size={20} />} onClick={() => onDelete(id)} />
        </UDTippy>
      </div>
    </div>
  );
}

export default MediaManagerTemplateListElement;
